export default "__VITE_ASSET__3c67e260__"